const route = {
	path: ':subsidiaryId?/journal',
	name: 'journal',
	meta: {
		title: 'Libro Diario',
	},
	component: () => import('@/pages/journal/page-journal'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/journal.js